module.exports = __webpack_public_path__ + "img/jordbaertaerte.28a231c6.jpg";